import type { HelloJSServiceDef } from 'hellojs';

let teamSnapConfig: HelloJSServiceDef = {
    name: 'teamsnap',

    oauth: {
        version: 2,
        auth: 'https://auth.teamsnap.com/oauth/authorize',
        grant: 'https://auth.teamsnap.com/oauth/token',
        response_type: 'code',
    },

    // Refresh the access_token once expired
    refresh: false,

    login: function (p) {
        // TODO: remove the two line once ADPRedirect.aspx is added to the msa redirect urls
        p.qs.redirect_uri = window.location.origin + '/mail/oauthRedirect.html';
        p.qs.state.redirect_uri = window.location.origin + '/mail/oauthRedirect.html';
    },

    // Authorization scopes
    scope: {
        basic: 'read',
    },

    // The delimiter between multiple scopes
    scope_delim: ' ',

    // API base URL
    base: 'https://api.teamsnap.com/v3/',
};
export default teamSnapConfig;
